import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { pageRoute } from 'shared/constants/routes.constants';
import { useRouter } from 'shared/hooks/use-router';
import useUser from 'shared/hooks/use-user';
import { getPageRoute } from 'shared/utils/get-dynamic-page-route';
export const useRedirectDisabledUser = () => {
  const $ = _c(4);
  const {
    isDisabled
  } = useUser();
  const router = useRouter();
  let t0;
  let t1;
  if ($[0] !== isDisabled || $[1] !== router) {
    t0 = () => {
      if (!isDisabled || router.pathname === pageRoute.Disabled) {
        return;
      }
      router.replace(getPageRoute(pageRoute.Disabled));
    };
    t1 = [isDisabled, router];
    $[0] = isDisabled;
    $[1] = router;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
};